// extracted by mini-css-extract-plugin
export default {"container":"zQQn2","green-circle":"Cndyf","tick-complete":"vL_PD","tick-complete-animated":"Zg9LI","tick":"YdYMc","grey-cross":"EeAo5","complete":"lFBSS"};